import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { useCampaignTimeFrameRestrictions } from './useCampaignTimeFrameRestrictions';

export const useStartDateFormFieldValue = () => {
    const { campaignGroupStartDate } = useCampaignTimeFrameRestrictions();
    const fieldProps = useFormFieldValue({ field: 'startDate' }, { campaignGroupStartDate });
    return fieldProps;
};
